import { createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ingredients_bottom.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7d4a828a")

_pushScopeId("data-v-7d4a828a")
const _hoisted_1 = { class: "detail-bottom-bar" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "detail-bottom-item-image" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "detail-bottom-item-icon",
    src: _imports_0
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "detail-bottom-item-text" }, "材料", -1)
const _hoisted_4 = { class: "detail-bottom-item-image" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "detail-bottom-item-text" }, "前の工程", -1)
const _hoisted_6 = { class: "detail-bottom-item-image" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "detail-bottom-item-text" }, "次の工程", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "detail-bottom-item",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickItem(_ctx.BOTTOM_ACTION_TYPE.INGREDIENTS)))
    }, [
      _hoisted_2,
      _hoisted_3
    ]),
    _createVNode("div", _mergeProps(_ctx.stepPrevEnable, {
      class: "detail-bottom-item",
      style: _ctx.styleCursorLeft(),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickItem(_ctx.BOTTOM_ACTION_TYPE.PREVIOUS_STEP)))
    }), [
      _createVNode("div", _hoisted_4, [
        _createVNode("img", {
          class: "detail-bottom-item-icon",
          src: _ctx.getCursorLeft()
        }, null, 8, ["src"])
      ]),
      _hoisted_5
    ], 16),
    _createVNode("div", _mergeProps(_ctx.stepNextEnable, {
      class: "detail-bottom-item",
      style: _ctx.styleCursorRight(),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickItem(_ctx.BOTTOM_ACTION_TYPE.NEXT_STEP)))
    }), [
      _createVNode("div", _hoisted_6, [
        _createVNode("img", {
          class: "detail-bottom-item-icon",
          src: _ctx.getCursorRight()
        }, null, 8, ["src"])
      ]),
      _hoisted_7
    ], 16)
  ]))
})